import { useState } from "react";
import { isNullUndefined } from "../../util/util";
import ModalContainerModule from "../modules/modalContainer";
import { ResponsiveRow } from "../../constants/layout.constants";
import { FormControl, InputLabel, OutlinedInput } from "@mui/material";
import { savePayBill } from "../../services/subscription.service";
import { issueResponseMessage } from "../../actions/message";

const AddEditPayBill = (props) => {
  const [payBill, setPayBill] = useState(props.selectedPayBill);

  const modalTitle = `${props.task} PayBill`;
  const acceptButtonText =
    !isNullUndefined(props.task) && props.task === "Edit" ? "Update" : "Save";
  const handlePaybillSave = () => {
    savePayBill({ payBill: payBill })
      .then((response) => {
        issueResponseMessage(response);
        props.closeModal(true);
      })
      .catch((error) => {});
  };

  const handleClose = () => {
    props.closeModal(false);
  };

  return (
    <ModalContainerModule
      size="xs"
      accept={handlePaybillSave}
      openModal={props.openModal}
      cancel={handleClose}
      modalTitle={modalTitle}
      acceptButtonText={acceptButtonText}
    >
      <ResponsiveRow sx={{ height: "auto" }} container>
        <FormControl
          item
          sx={{
            width: { xs: "100%", lg: "100%" },
            marginBottom: "10px",
          }}
        >
          <InputLabel required>Pay Bill</InputLabel>
          <OutlinedInput
            label={"Pay Bill"}
            sx={{ width: { xs: "100%", md: "=100%" } }}
            id={"payBill"}
            type={"number"}
            onChange={(event) => {
              setPayBill(event.target.value);
            }}
            value={payBill}
          />
        </FormControl>
      </ResponsiveRow>
    </ModalContainerModule>
  );
};

export default AddEditPayBill;
